module.exports = __webpack_public_path__ + "d44c20f69d083cd43ca9925e2e7cf3c7.pdf";